import { render, staticRenderFns } from "./treeForm.vue?vue&type=template&id=b0c0e33c&scoped=true&"
import script from "./treeForm.vue?vue&type=script&lang=js&"
export * from "./treeForm.vue?vue&type=script&lang=js&"
import style0 from "./treeForm.vue?vue&type=style&index=0&id=b0c0e33c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c0e33c",
  null
  
)

export default component.exports